<template>
    <div class="menubtn" id="menubtn" ref="menubtn" :class="{on: activemenu}">
      <ul>
        <li><a @click="golink('message')"><img src="@/assets/images/icon-home.png" alt=""><span>精选</span></a></li>
        <li><a @click="golink('mymessage')"><img src="@/assets/images/icon-my.png" alt=""><span>我的</span></a></li>
        <li><a @click="golink('addmessage')"><img src="@/assets/images/icon-addmessage.png" alt=""><span>留言</span></a></li>
      </ul>
      <div class="btnselect" @click.stop="btnselect">
        <img src="@/assets/images/icon-menu.png" class="menu" alt="">
        <img src="@/assets/images/icon-close.png" class="menuclose" alt="">
      </div>
    </div>
</template>

<script>
export default {
  name: 'menus',
  data () {
    return {
      activemenu: false
    }
  },
  mounted () {
  },
  methods: {
    btnselect () {
      this.activemenu = !this.activemenu
    },
    istypeFlag (url) {
      let querydata = {}
      querydata = this.$cookie.get('typeflag') === 'false' ? {museumCode: this.$cookie.get('museumCode'), typeflag: 1, theme: this.$cookie.get('themeName')} : {museumCode: this.$cookie.get('museumCode'), theme: this.$cookie.get('themeName')}
      this.$router.push({path: '/' + url, query: querydata})
    },
    golink (url) {
      this.activemenu = false
      if (this.$cookie.get('token')) {
        this.istypeFlag(url)
      } else {
        if (!isNaN(parseInt(this.$route.query.museumCode, 10)) && this.$cookie.get('_uid')) {
          this.$http({
            url: this.$http.adornUrl(`/api/auth/jwt/login-app?fid=${this.$route.query.museumCode}`),
            method: 'post'
          }).then((res) => {
            if (res.data.status === 200) {
              this.$cookie.set('token', res.data.data.token)
              this.istypeFlag(url)
            } else {
              this.$message.error(res.data.message)
            }
          })
        } else {
          this.istypeFlag('login')
        }
      }
    }
  }
}
</script>

<style lang="scss">
.menubtn{
  width: 54px;
  height: 54px;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  background: rgba(161,27,0,0.7);
  text-align: center;
  -webkit-border-radius: 27px;
  -moz-border-radius: 27px;
  border-radius: 27px;
  transition: height 0.3s;
  -moz-transition: height 0.3s;
  -webkit-transition: height 0.3s;
  -o-transition: height 0.3s;
  overflow: hidden;
  .btnselect{
    width: 54px;
    height: 54px;
    border-radius: 50%;
    background: #a11b00;
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 14px 0 0;
    .menu{
      display: block;
    }
    .menuclose{
      display: none;
    }
  }
  ul{
    display: none;
    li{
      margin: 20px 0 0;
    }
  }
  img{
    width: 26px;
    height: 26px;
    vertical-align: top;
    margin: 0px auto 3px;
  }
  span{
    display: block;
    font-size: 12px;
    color:#fff;
  }
  &.on{
    height: 270px;
    .btnselect{
      .menuclose{
        display: block;
      }
      .menu{
        display: none;
      }
    }
    ul{
      display: block;
    }
  }
}
.lstheme{
  .menubtn{
    background: url('../../assets/images/icon_bar1.png') no-repeat;
    background-size: 100% 100%;
    .btnselect{
      background: url('../../assets/images/icon_ls_btnbg.png') no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/menus.vue